import Vue from 'vue'
import $glDom from '@/services/$glDom'

// init $glEventHub
let $glEventHub = new Vue()

// on store.config.commit -> ensure favicon is up to date
$glEventHub.$on('store.config.commit', () => {
  $glDom.setFavicon()
})

// export $glEventHub
export default $glEventHub



// WEBPACK FOOTER //
// ./src/services/$glEventHub.js